'use strict';

const $ = window.jQuery;

const select2FR = {
    errorLoading: () => 'Les résultats ne peuvent pas être chargés.',
    inputTooLong: (e) => {
        const n = e.input.length - e.maximum;
        return `Supprimez ${n} caractère${n > 1 ? 's' : ''}`;
    },
    inputTooShort: (e) => {
        const n = e.minimum - e.input.length;
        return `Saisissez au moins ${n} caractère${n > 1 ? 's' : ''}`;
    },
    loadingMore: () => 'Chargement de résultats supplémentaires\u2026',
    maximumSelected: (e) => `Vous pouvez seulement sélectionner ${e.maximum} élément${e.maximum > 1 ? 's' : ''}`,
    noResults: () => 'Aucun résultat trouvé',
    searching: () => 'Recherche en cours\u2026',
    removeAllItems: () => 'Supprimer tous les éléments',
};

export default class Select2Init {
    constructor() {
        $('.select-field').find('select').select2({
            language: select2FR,
            width: '100%',
            theme: 'primx'
        }).on('select2:open', function () {
            $('.select2-results__options').niceScroll({
                cursorcolor: '#333',
                cursorborder: '0',
                cursorborderradius: '0'
            });
        });
    }
}
